import {Action} from 'redux';
import {AssoMediaEvent, Media, Playlist, Tempo} from '../entities';

export enum TPlaylist {
  SET_EVENT = 'SET_EVENT',
  SET_EVENTS = 'SET_EVENTS',
  SET_TEMPO = 'SET_TEMPO',
  PLAYLIST_ADD = 'PLAYLIST_ADD',
  PLAYLIST_REMOVE = 'PLAYLIST_REMOVE',
  FETCH_TEMPOS = 'FETCH_TEMPOS',
  FETCH_EVENTS = 'FETCH_EVENTS',
  ADD_TRACKS = 'ADD_TRACKS',
  CREATE_PLAYLIST = 'CREATE_PLAYLIST'
}

export interface ISetEvent extends Action {
  type: TPlaylist.SET_EVENT;
  payload: Playlist;
}
export const ASetEvent = (payload: Playlist): ISetEvent => ({ type: TPlaylist.SET_EVENT, payload });

export interface ISetTempo extends Action {
  type: TPlaylist.SET_TEMPO;
  payload: Tempo;
}
export const ASetTempo = (payload: Tempo): ISetTempo => ({ type: TPlaylist.SET_TEMPO, payload });


export interface IPlaylistAdd extends Action {
  type: TPlaylist.PLAYLIST_ADD;
  payload: Media;
}
export const APlaylistAdd = (payload: Media): IPlaylistAdd => ({ type: TPlaylist.PLAYLIST_ADD, payload });

export interface IPlaylistRemove extends Action {
  type: TPlaylist.PLAYLIST_REMOVE;
  payload: string;
}
export const APlaylistRemove = (payload: string): IPlaylistRemove => ({ type: TPlaylist.PLAYLIST_REMOVE, payload });


export interface IFetchEvents extends Action {
  type: TPlaylist.FETCH_EVENTS;
}
export const AFetchEvents = (): IFetchEvents => ({ type: TPlaylist.FETCH_EVENTS });

export interface IFetchTempos extends Action {
  type: TPlaylist.FETCH_TEMPOS;
}
export const AFetchTempos = (): IFetchTempos => ({ type: TPlaylist.FETCH_TEMPOS });

interface IAddTracksPayload {
  playlistId: string;
  assoMediaEvent: AssoMediaEvent[];
}
export interface IAddTracks extends Action {
  type: TPlaylist.ADD_TRACKS;
  payload: IAddTracksPayload;
}
export const AAddTracksToPlaylist = (payload: IAddTracksPayload): IAddTracks => ({ type: TPlaylist.ADD_TRACKS, payload });

export interface ICreatePlaylist extends Action {
  type: TPlaylist.CREATE_PLAYLIST;
  payload: Playlist;
}
export const ACreatePlaylist = (payload: Playlist): ICreatePlaylist => ({ type: TPlaylist.CREATE_PLAYLIST, payload });
